// Lógica compartida para decidir qué autor de una pregunta se muestra
// visualmente (foto + username) en el concurso, tanto en la página /quiz como
// en el overlay de OBS. Fuente única de las exclusiones.

const normalizarTexto = (valor) => String(valor || '')
  .trim()
  .toLowerCase()
  .normalize('NFD')
  .replace(/[̀-ͯ]/g, '');

// Nombres de autor que NUNCA muestran foto ni username en el concurso.
// (Anónimo, Sistema, ChatGPT y el propio streamer.)
export const AUTORES_EXCLUIDOS_VISUALMENTE = [
  'sistema',
  'anonimo',
  'chatgpt',
  'diegons',
];

// Roles de staff (moderador / administrador): tampoco se muestran.
const ROLES_STAFF = [
  'admin',
  'administrador',
  'administrator',
  'moderador',
  'moderator',
];

// A partir del objeto pregunta enriquecido por el backend
// (rol_autor / autor_nombre / autor_foto_perfil), deriva qué mostrar.
export const derivarAutorPregunta = (pregunta) => {
  const rol = normalizarTexto(
    pregunta?.rol_autor || pregunta?.autor_rol || pregunta?.rol || ''
  );
  const esStaff = ROLES_STAFF.includes(rol);

  const nombreAutor = String(pregunta?.autor_nombre || pregunta?.autor || '').trim();
  const excluido = AUTORES_EXCLUIDOS_VISUALMENTE.includes(normalizarTexto(nombreAutor));

  const esAutorUsuario = Boolean(nombreAutor) && !esStaff && !excluido;
  const fotoAutor = String(pregunta?.autor_foto_perfil || '').trim();

  return {
    nombreAutor,
    fotoAutor,
    esAutorUsuario,
    mostrarFoto: esAutorUsuario && Boolean(fotoAutor),
    mostrarIcono: esAutorUsuario && !fotoAutor,
  };
};
